import { ExpressActivatedUsersFragment, LeaderboardEventAggregate } from '../../api';
import { flattenDeep, values } from 'lodash';
import { UserSearchesV2Filter } from './components/UserManagement/type';

export const getConfigScores = (scoringAggregate: LeaderboardEventAggregate) => {
  const events = values(scoringAggregate);
  const scores = events.map(event => values(event));
  return flattenDeep(scores);
};

export const getExpressActivationResults = (
  filter: UserSearchesV2Filter,
  results: ExpressActivatedUsersFragment[]
): ExpressActivatedUsersFragment[] => {
  if (filter.emails.length) {
    return results.filter(user => filter.emails.includes(user.email));
  }

  return results;
};
